import styled from 'styled-components'
import {Nav} from 'react-bootstrap'

export const NavLink = styled(Nav.Link)`
  color: white !important;
`
